import { useSetAtom } from 'jotai';
import {
  LucideChevronRight,
  LucideClipboardList,
  LucideHash,
} from 'lucide-react';

import { $location } from '../../../../shared/state/location.state';
import { RenderMode } from '../../../assistant/_components/chat/entity-reference/types';

interface TaskData {
  id: string;
  documentNumber: string;
  description?: string;
  status?: string;
  type?: string;
}

interface TaskReferenceProps extends TaskData {
  mode: RenderMode | string;
}

export function TaskReference({
  mode,
  id: _id,
  documentNumber,
  description,
  status,
  type,
}: TaskReferenceProps) {
  const setLocation = useSetAtom($location);

  const handleClick = () => {
    setLocation({ pathname: `/facilities/management` });
  };

  if (mode === RenderMode.CARD || mode === 'card') {
    return (
      <span
        className="group my-1 inline-flex max-w-sm min-w-[280px] cursor-pointer items-center gap-3 rounded-lg border border-neutral/20 bg-white px-3 py-2.5 transition-all hover:border-primary/30 hover:shadow-md"
        onClick={handleClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleClick();
          }
        }}
      >
        <span className="flex-1">
          <span className="block text-base font-semibold text-neutral">
            Task #{documentNumber}
          </span>
          {description && (
            <span className="mt-0.5 block text-sm text-neutral/60">
              {description}
            </span>
          )}
          {(type || status) && (
            <span className="mt-1 flex items-center gap-1 text-xs text-neutral/50">
              {type && (
                <span className="flex items-center gap-1">
                  <LucideClipboardList className="h-3.5 w-3.5" />
                  {type}
                </span>
              )}
              {type && status && <span className="mx-0.5">&middot;</span>}
              {status && (
                <span className="flex items-center gap-1">
                  <LucideHash className="h-3.5 w-3.5" />
                  {status}
                </span>
              )}
            </span>
          )}
        </span>
        <LucideChevronRight className="h-5 w-5 shrink-0 text-neutral/40 transition-colors group-hover:text-primary" />
      </span>
    );
  }

  if (mode === RenderMode.LINK || mode === 'link') {
    return (
      <button
        onClick={handleClick}
        className="inline-flex items-center gap-1 font-medium text-primary hover:text-primary-darker hover:underline"
      >
        <span>Task #{documentNumber}</span>
      </button>
    );
  }

  return null;
}
